import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconOpencode: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconOpencode"><Path opacity="0.4" d="M16 10.0002V18.0002H8V10.0002H16Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M20 22H4V2H20V22ZM16 6H8V18H16V6Z" fill="currentColor"/></CentralIconBase>;
});

export default IconOpencode;
